import { t } from "i18next";

import Chevron from "@/assets/icons/chevron.svg?react";
import Info from "@/assets/icons/info.svg?react";
import Mark from "@/assets/icons/mark.svg?react";
import { BlinkDots } from "@/components/BlinkDots";
import { logger } from "@/services/config/mixpanel";
import { splitCamelCase } from "@/utils";

import styles from "./styles";
import { ILevelButton, TLevelButtonStatus } from "../../interfaces";

export const LevelButton = ({ name, handler, icon, status, disabled, iconBg, loading }: ILevelButton) => {
  const statusData: Record<TLevelButtonStatus, null | { title: string | undefined; icon: JSX.Element }> = {
    empty: null,
    pending: { title: t("Levels.Pending"), icon: <Info /> },
    completed: { title: t("Levels.Completed"), icon: <Mark /> },
  };
  const currentStatus = statusData[status];
  const translate = t(`Actions.${name}`);
  return (
    <styles.LevelButton
      onClick={() => {
        if (disabled) return;
        logger.trackEvent(splitCamelCase(name));
        handler();
      }}
      $disabled={disabled}
    >
      <styles.LevelButtonIcon $bg={iconBg}>{icon}</styles.LevelButtonIcon>
      <styles.LevelButtonBody>
        <p>{loading ? <BlinkDots>{translate}</BlinkDots> : translate}</p>
        {currentStatus && (
          <styles.LevelButtonStatus $status={status}>
            {currentStatus.icon}
            {currentStatus.title}
          </styles.LevelButtonStatus>
        )}
      </styles.LevelButtonBody>
      {status !== "completed" && <Chevron />}
    </styles.LevelButton>
  );
};
